import http from '@/common/request/axios';

export const creditService = {
    transaction: {
        list({ offset, limit, accountId }: any) {
            return http.doGet('admin/credit/transaction/' + accountId, { offset, limit });
        },

        listPayment({ offset, limit, accountId }: any) {
            return http.doGet('admin/credit/transaction/' + accountId + '/payment', { offset, limit });
        }
    },

    getAvgPayment(accountId: any) {
        return http.doGet('admin/credit/' + accountId + '/payment/average');
    },

    ticket: {
        create(name: any, amount: any) {
            return http.doPost('admin/credit/ticket', {
                name: name,
                amount: amount
            });
        },

        update(itemId: any, name: any, amount: any) {
            return http.doPut('admin/credit/ticket/' + itemId, {
                name: name,
                amount: amount
            });
        },

        get(itemId: any) {
            return http.doGet('admin/credit/ticket/' + itemId);
        },

        list() {
            return http.doGet('admin/credit/ticket');
        },

        remove(itemId: any) {
            return http.doDelete('admin/credit/ticket/' + itemId);
        }
    }
};
